import React from 'react';
import { Card } from 'react-bootstrap';
import {
  MdAccessTime,
  MdCheckCircle,
  MdAddCircle,
  MdFreeBreakfast,
  MdWork,
  MdPause,
} from 'react-icons/md';

const convertSeconds = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
};

const TimeTrackingCard = ({ summary }) => {
  const items = [
    {
      Icon: MdAccessTime,
      label: 'Total',
      value: convertSeconds(summary.total),
    },
    {
      Icon: MdCheckCircle,
      label: 'Tracked',
      value: convertSeconds(summary.tracked),
    },
    {
      Icon: MdAddCircle,
      label: 'Manually added',
      value: convertSeconds(summary.manuallyAdded),
    },
    {
      Icon: MdFreeBreakfast,
      label: 'Idle',
      value: convertSeconds(summary.idle),
    },
    { Icon: MdWork, label: 'Paid leave', value: summary.paidLeave.toString() },
    { Icon: MdPause, label: 'Break', value: convertSeconds(summary.break) },
  ];

  return (
    <Card className="time-tracking-card">
      <Card.Body>
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          {items.map((item, index) => (
            <div key={index} className="time-tracking-item text-center p-2">
              <item.Icon
                className="text-purple mb-2"
                style={{ fontSize: '25px' }}
              />
              <div className="font-14">
                {item.label}
                <br />
                <strong>{item.value}</strong>
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default TimeTrackingCard;
